<div>
  <a class="event-image "
  [routerLink]="routerLink">

 <img class="cover-img "
      [src]="imageSrc" alt="">

      <!-- <ng-container *ngIf="isAvifImage(venueLogoImage); else normalImage">
        <picture>
            <source
              media="(min-width:450px) and (max-width:650px)"
              [srcset]="venueMidLogoImage"
            />
            <source
              media="(max-width:450px)"
              [srcset]="venueSmallLogoImage"
            />
            <source
              media="(min-width:650px)"
              [srcset]="venueLogoImage"
            />
        
            <img
              class="noGallery"
              [src]="eventNoSrc"
              [alt]="eventsDetailListByVenue?.venueName"
              loading="lazy"
              #venueLogoImage
              (load)="onLoadImage(venueLogoImage)"
            />
        </picture>
      </ng-container>
        
      <ng-template #normalImage>
      <img
          class=""
          #venueLogoImage
          (load)="onLoadImage(venueLogoImage)"
          loading="lazy"
          [src]="venueLogoImage"
          [alt]="eventsDetailListByVenue?.venueName"
      />
      </ng-template> -->

 <span class="ticket-count"
     [style.display]="displayTicketCount ? 'block' : 'none'"
      matBadgeColor="warn"
      matBadgePosition="below after"
      [matBadge]="'x'+count"></span>
  </a>
</div>

